import { DEFAULT_COUNTRY } from "@constants/store";
import { createSlice } from "@reduxjs/toolkit";

const INITIAL_STATE = {
  data: DEFAULT_COUNTRY,
};

const syncReducers = {
  setCountry: (state, { payload }) => {
    return { ...state, data: { ...payload } };
  },
};

const store = createSlice({
  name: "country",
  initialState: INITIAL_STATE,
  reducers: syncReducers,
});

export const { setCountry } = store.actions;

export default store.reducer;
